
import { defineComponent, onBeforeMount, PropType, reactive, ref } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

// @composable
import useNotifications from '@/common/composable/useNotifications'

// @validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// @types
import {
    CrmUpdateTaskOnCallPayload,
    CrmWaitListProcessingStatus,
    Task,
} from '@/new-services/types/crm'

// @api
import crmAPI from '@/new-services/crm.service'

export default defineComponent({
    components: { NewModal, NewInput, NewSelect },
    props: {
        task: {
            type: Object as PropType<Task>,
            required: true,
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const is_loading = ref(false)

        const state = reactive({
            phoneNumber: null as string | null,
            processingStatusId: null as number | null,
            comment: null as string | null,
            value: null as string | null,
        })

        const state_form$ = useVuelidate(
            {
                phoneNumber: { required },
                processingStatusId: { required },
            },
            state
        )

        const onCancel = () => {
            if (is_loading.value) return
            emit('cancel')
        }

        const onSubmit = async () => {
            if (is_loading.value) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                is_loading.value = true

                const payload: CrmUpdateTaskOnCallPayload = {
                    phoneNumber: state.phoneNumber as string,
                    processingStatusId: state.processingStatusId as number,
                    value: state.value,
                    comment: state.comment,
                }

                await crmAPI.updateTaskOnCall(props.task.id, payload)

                notifications.notify({ type: 'success', title: 'Запись сохранена' })
                emit('submit')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При редактировании записи произошла ошибка',
                })
            } finally {
                is_loading.value = false
            }
        }

        const statuses_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as CrmWaitListProcessingStatus[],
        })

        const loadStatuses = async () => {
            try {
                statuses_state.is_loading = true

                const response = await crmAPI.getWaitListProcessingStatuses()
                statuses_state.list = response.data.data
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении статусов произошла ошибка',
                })
            } finally {
                statuses_state.is_loading = false
            }
        }

        const initializeState = () => {
            if (props.task) {
                state.phoneNumber = props.task.phoneNumber

                if (props.task.processingStatus) {
                    state.processingStatusId = props.task.processingStatus.id
                }
            }
        }

        onBeforeMount(() => {
            initializeState()
            loadStatuses()
        })

        return {
            is_loading,
            state,
            state_form$,
            onCancel,
            onSubmit,
            statuses_state,
            loadStatuses,
        }
    },
})
